import { Toaster } from "@/components/ui/sonner";
import { useAppleSmartBanner } from "@/hooks/useAppleSmartBanner";
import { cn } from "@roman/shared/utils";
import { useEffect, useMemo } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Footer } from "./Footer";
import { Header } from "./Header";

const hiddenMenuPages = [
  "/login",
  "/register",
  "/profile/edit",
  //TODO: The topPage URL needs to be changed.
  "/top",
  "/referral/register",
];

export const Layout = () => {
  const location = useLocation();
  const pathname = location.pathname;

  // Update Apple Smart Banner with current page URL
  useAppleSmartBanner();

  const isShowMenuNavigationBarPC = useMemo(() => !hiddenMenuPages.includes(pathname), [pathname]);

  const currentPath = useMemo(() => {
    return `${location.pathname}${location.search}`;
  }, [location]);

  // biome-ignore lint/correctness/useExhaustiveDependencies: We have to use this because we want to scroll to top when the page changes.
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [currentPath]);

  return (
    <>
      <div className="min-h-screen flex flex-col">
        <Header />
        {!isShowMenuNavigationBarPC && <Outlet />}
        {isShowMenuNavigationBarPC && (
          <div className="flex-1 flex">
            <div className={cn("relative w-full")}>
              <div className={cn("", "max-w-[1000px] mx-auto")}>
                <Outlet />
              </div>
            </div>
          </div>
        )}
        <Toaster />
        <Footer />
      </div>
    </>
  );
};
